export const IN_PROGRESS: Operation$Status = 0;
export const SUCCESS: Operation$Status = 1;
export const FAILED: Operation$Status = 2;
